import { render, staticRenderFns } from "./Supporters.vue?vue&type=template&id=6b7db95c&"
import script from "./Supporters.vue?vue&type=script&lang=js&"
export * from "./Supporters.vue?vue&type=script&lang=js&"
import style0 from "./Supporters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports